import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const cancelTripAction = {
    ...operations,
    ...selectors,
};

export {
    cancelTripAction,
};
export default {
    [namespace]: reducer,
};
